import {Component, OnInit} from '@angular/core';
import {NodeBuilder} from '../../../../../../../shared/models';
import {AiAssistantNode, NODE_TYPE} from './aiAssistant';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {AiAssistantIds, AiAssistantService} from './ai-assistant.service';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import {tap} from 'rxjs/operators';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import {FlowBuilderService} from '../../../../../services/flowBuilder/flow-builder.service';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { NgTemplateOutlet, NgStyle, NgClass } from '@angular/common';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatOption } from '@angular/material/select';
import { LoadingIconComponent } from '../../../../../../../shared/components/loading-icon/loading-icon.component';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Component({
    selector: 'app-ai-assistant',
    templateUrl: './ai-assistant.component.html',
    styleUrls: ['./ai-assistant.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, ClickatellFormValidationComponent, ActiveFormDirective, MatButtonToggleGroup, MatButtonToggle, NgTemplateOutlet, CMSComponent, NextSelectorComponent, MatInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, NgStyle, NgClass, LoadingIconComponent, MatSlideToggle]
})
export class AiAssistantComponent extends NodeBuilder implements OnInit {

    AiAssistantForm: UntypedFormGroup = null;
    assistantIds: AiAssistantIds[] = undefined;
    assistantIdsFiltered: AiAssistantIds[] = undefined;

    constructor(private assistantService: AiAssistantService, private flowBuilder: FlowBuilderService) {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
        this.assistantService.getAiAssistants()
            .pipe(
                tap(aiAssistants => {
                    this.assistantIds = aiAssistants;
                    this.assistantIdsFiltered = aiAssistants;
                }),
                tap(() => {
                    this.flowBuilder.setNodeValid(this.nodeFlowDetails.stepId, this.isNodeValid);
                })
            )
            .subscribe();
    }

    set buildForm(stepData: any) {

        this.AiAssistantForm = AiAssistantNode.toForm(stepData, this.canEdit);

        switch (this.AiAssistantForm.get('inferenceType').value) {
            case 'context_router':
                this.AiAssistantForm.get('assistantId').disable();
                this.flowBuilder.setNodeValid(this.nodeFlowDetails.stepId, this.isNodeValid);
                break;
        }


        if (this.AiAssistantForm.get('errorNext').value === newStepValue) {
            this.AiAssistantForm.get('errorNext').setValue('step' + this.getNextStep());
        }
        if (this.AiAssistantForm.get('successNext').value === newStepValue) {
            this.AiAssistantForm.get('successNext').setValue('step' + this.getNextStep());
        }
    }

    get getStepData(): {} {

        const node = new AiAssistantNode();
        node.setNodeData(this.AiAssistantForm.getRawValue());

        return node.nodeData;
    }

    get isNodeValid(): boolean {
        this.AiAssistantForm.markAllAsTouched();
        return this.AiAssistantForm.valid;
    }


    public assistantIdFilter(element: HTMLInputElement) {
        const filterValue = element.value;
        this.assistantIdsFiltered = this.assistantIds?.filter(option => option.name.includes(filterValue));
    }

    assistantIdDisplay(id: string): string {
        if (this.assistantIds && id) {
            return this.assistantIds.find(value => value.assistantId === id).name;
        }

        return '';
    }

    public modeChanged(event: MatButtonToggleGroup): void {
        switch (event.value) {
            case 'assistant':
                this.AiAssistantForm.get('assistantId').enable();
                break;
            case 'context_router':
                this.AiAssistantForm.get('assistantId').disable();
                break;
        }
    }
}
